module.exports = __webpack_public_path__ + "static/media/arrived.026b63df.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/PennAppsF18/arrived.png
// module id = 146
// module chunks = 0